// extracted by mini-css-extract-plugin
export var root = "section-module--root--gJuE1";